import React from 'react';
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";


import ErrorMessage from './ErrorMessage';
import { diffCheck, stalledTransactionLink, statusColourName, userProfileLink } from '../../../../../../util/Helpers';
import { useGetStalledTransactionsQuery } from '../../../../../../../redux/apiSlice';

const ResolveTransactionAction = ({ show, action: { action, error, data }, onHide }) => {
    const { data: stalledTransactions } = useGetStalledTransactionsQuery(data?.flaggedId);


    return <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
    >
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-danger mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                    />
                </span> {action}
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
        </Modal.Header>
        <Modal.Body>
            <ErrorMessage {...{ error }} />
            <div className="px-md-5">
                <div className="row mt-4">
                    <div className="col-md-4 h6">AutoId</div>
                    <div className="col-md h6 text-muted">{data?.autoId}</div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">Comment</div>
                    <div className="col-md h6 text-muted">{diffCheck(data?.comment, data?.resolutionComment)}</div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">Type</div>
                    <div className="col-md h6 text-muted">
                        {diffCheck(data?.status, data?.resolutionType)}
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-6 py-2">
                        <a
                            href={userProfileLink(stalledTransactions?.userId, stalledTransactions?.accountId)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-block"
                        >
                            View User's Profile
                        </a>
                    </div>

                    <div className="col-md-6 py-2">
                        <a
                            href={stalledTransactionLink(data?.flaggedId)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-block"
                        >
                            View Flagged Transaction
                        </a>
                    </div>
                </div>

            </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
    </Modal>
}

export default ResolveTransactionAction;